// Schema mapping for all pages in the Ishan Tech website
export const SCHEMA_MAPPING = {
  // Home page
  '/': 'HomePageSchema',
  
  // About and company pages
  '/about-us': 'AboutUsSchema',
  '/our-customers': 'CustomersSchema',
  '/our-partners': 'PartnersSchema',
  '/our-quality-policy': 'AboutUsSchema',
  '/careers': 'CareersSchema',
  '/location': 'AboutUsSchema',
  
  // Data Center Services
  '/data-center-services': 'CloudServicesSchema',
  '/data-center-services/cloud-services': 'CloudServicesSchema',
  '/aws-services': 'AwsServicesSchema',
  '/data-center-services/cloud-platform': 'CloudPlatformSchema',
  '/data-center-services/colocation': 'ColocationSchema',
  
  // Cloud Services
  '/cloud/calculator': 'CloudCalculatorSchema',
  '/cloud/plans': 'CloudPlansSchema',
  
  // Colocation Services
  '/data-center-services/colocation/gandhinagar': 'ColocationSchema',
  '/data-center-services/colocation/chennai': 'ColocationSchema',
  '/data-center-services/colocation/mumbai': 'ColocationSchema',
  
  // Network Services
  '/network-services': 'NetworkServiceSchema',
  '/network-services/enterprise-connectivity': 'EnterpriceConnectivity',
  '/network-services/high-speed-broadband': 'HighSpeedBroadband',
  '/network-services/manage-sdwan': 'NetworkServiceSchema',
  '/network-services/unified-communication': 'UnifiedCommunication',
  '/network-services/carrier-based-cloud': 'CarrierBasedCloud',
  '/network-services/high-speed-broadband/plans': 'HighSpeedBroadband_Plans',
  
  // Systems Integration
  '/systems-integration': 'SystemsIntegrationSchema',
  '/systems-integration/managed-services': 'ManagedServices',
  '/systems-integration/data-lifecycle-solutions': 'DataLifeCycleSolutions',
  '/systems-integration/secure-and-scalable-digital': 'SecureAndScalableDigital',
  '/systems-integration/smart-city-services': 'SmartCityServices',
  
  // Cybersecurity
  '/cybersecurity-services': 'CybersecuritySchema',
  '/manage-sase': 'CybersecuritySchema',

  // Sovereign AI & Cloud
  '/sovereign-ai-and-cloud-services': 'SovereignAiCloudSchema',
  
  // Contact Pages
  '/contact': 'ContactSchema',
  '/contacts/contact-for-sales': 'ContactSchema',
  '/contacts/contact-for-customer-service': 'ContactSchema',
  '/contacts/media-inquires': 'ContactSchema',
  '/contacts/partner-with-us': 'ContactSchema',
  '/contacts/nodal-and-appellate-contact': 'ContactSchema',
  
  // Apple Services
  '/apple': 'AppleServicesSchema',
  '/apple/enterprise': 'AppleServicesSchema',
  '/apple/applecare': 'AppleServicesSchema',
  '/apple/apple-mac-doe-that': 'AppleServicesSchema',
  
  // Dell Services
  '/dell/server-storage': 'DellServicesSchema',
  
  // Internet Services
  '/internet-services': 'InternetServicesSchema',
  
  // Events and Updates
  '/events': 'EventsSchema',
  '/latest-updates': 'EventsSchema',
  '/awards': 'EventsSchema',
  
  // Legal Pages
  '/privacy-policy': 'PrivacyPolicySchema',
  '/terms-and-condition': 'TermsConditionsSchema',
  '/downloads-resources': 'AboutUsSchema',

  // Jcnl Broadband
  '/jcnlbroadband': 'JcnlSchema',
}

// Service-specific data for dynamic schemas
export const SERVICE_DATA = {
  // Network Services
  'enterprise-connectivity': {
    name: 'Enterprise Connectivity Solutions',
    description: 'Reliable enterprise network connectivity solutions'
  },
  'high-speed-broadband': {
    name: 'High-Speed Broadband Services',
    description: 'Ultra-fast broadband internet for businesses'
  },
  'manage-sdwan': {
    name: 'Managed SD-WAN Services',
    description: 'Software-defined wide area network management'
  },
  'unified-communication': {
    name: 'Unified Communication Solutions',
    description: 'Integrated communication and collaboration tools'
  },
  'carrier-based-cloud': {
    name: 'Carrier-Based Cloud Services',
    description: 'Carrier-grade cloud infrastructure solutions'
  },
  
  // Systems Integration
  'managed-services': {
    name: 'Managed IT Services',
    description: 'Comprehensive managed IT infrastructure services'
  },
  'data-lifecycle-solutions': {
    name: 'Data Lifecycle Management',
    description: 'End-to-end data lifecycle management solutions'
  },
  'secure-and-scalable-digital': {
    name: 'Secure Digital Transformation',
    description: 'Secure and scalable digital transformation services'
  },
  'smart-city-services': {
    name: 'Smart City Solutions',
    description: 'Intelligent city infrastructure and services'
  },
  
  // Apple Services
  'apple-enterprise': {
    name: 'Apple Enterprise Solutions',
    description: 'Enterprise Apple device management and support'
  },
  'applecare': {
    name: 'AppleCare Support Services',
    description: 'Professional AppleCare support and maintenance'
  },
  'apple-mac-doe-that': {
    name: 'Apple Mac Enterprise Services',
    description: 'Mac deployment and enterprise services'
  },
  
  // Contact Types
  'sales': {
    name: 'Sales Contact',
    description: 'Get in touch with our sales team'
  },
  'customer-service': {
    name: 'Customer Service',
    description: 'Customer support and service inquiries'
  },
  'media': {
    name: 'Media Inquiries',
    description: 'Press and media contact information'
  },
  'partner': {
    name: 'Partner With Us',
    description: 'Partnership and collaboration opportunities'
  }
}

// Location data for colocation services
export const LOCATION_DATA = {
  'gandhinagar': {
    name: 'Gandhinagar',
    description: 'State-of-the-art colocation facility in Gandhinagar, Gujarat',
    image: 'https://ishantechnologies.com/api/static/82694lender_pg_co_location_gandhinagar_jpg.jpg',
    address: {
      "@type": "PostalAddress",
      "streetAddress": "310, 3rd Floor, B2 Wing, Boomerang, Chandivali, Andheri East,",
      "addressLocality": "Mumbai",
      "postalCode": "400072",
      "addressCountry": "India",
    }
  },
  'chennai': {
    name: 'Chennai',
    description: 'Premium colocation services in Chennai, Tamil Nadu',
    image: 'https://ishantechnologies.com/api/static/524889255_ch__banner_clip_group__png_png.png',
    address: {
      "@type": "PostalAddress",
      "streetAddress": "5th Floor, Door No. 74, Fagun Mansion, Ethiraj Salai, Egmore,",
      "addressLocality": "chennai",
      "postalCode": "600008",
      "addressCountry": "India",
    }
  },
  'mumbai': {
    name: 'Mumbai',
    description: 'Enterprise colocation facility in Mumbai, Maharashtra',
    image: 'https://ishantechnologies.com/api/static/6610646226_ch__banner_clip_group__png_png.png',
    address: {
      "@type": "PostalAddress",
      "streetAddress": "310, 3rd Floor, B2 Wing, Boomerang, Chandivali, Andheri East,",
      "addressLocality": "Mumbai",
      "postalCode": "400072",
      "addressCountry": "India",
    }
  }
}